<template>
  <operationCarLicense/>
</template>
<script>
import operationCarLicense from '../components/operationCarLicense/index.vue'

export default {
  name: 'licencesAdd',
  components: {
    operationCarLicense,
  },
}
</script>
